import React from "react";
import { OutboundEmailStatus } from "intake_shared/src/types";

type EmailStatusTagProps = {
    status?: OutboundEmailStatus | string;
    className?: string;
};

const STATUS_CONFIG = {
    [OutboundEmailStatus.SENT]: {
        label: "Sent",
        color: "#15B097",
        backgroundColor: "#E6F7F3",
    },
    [OutboundEmailStatus.FAILED]: {
        label: "Failed",
        color: "#FB3748",
        backgroundColor: "#FDECEF",
    },
    [OutboundEmailStatus.UNSCHEDULED]: {
        label: "Unscheduled",
        color: "#FF8C00",
        backgroundColor: "#FFF4E6",
    },
    [OutboundEmailStatus.PENDING]: {
        label: "Pending",
        color: "#3A7AFE",
        backgroundColor: "#EBF2FF",
    },
} as const;

export default function EmailStatusTag({ status, className }: EmailStatusTagProps) {
    const normalizedStatus = String(status || "").toLowerCase();

    const config =
        Object.entries(STATUS_CONFIG).find(
            ([key]) => key.toLowerCase() === normalizedStatus
        )?.[1] || STATUS_CONFIG[OutboundEmailStatus.PENDING];

    return (
        <span
            className={className}
            style={{
                display: "inline-block",
                padding: "2px 8px",
                borderRadius: 12,
                backgroundColor: config.backgroundColor,
                color: config.color,
                fontWeight: 600,
                fontSize: 12,
                lineHeight: "16px",
                whiteSpace: "nowrap",
            }}
        >
            {config.label}
        </span>
    );
}
